import swal from "sweetalert2";
import AdminApi from "../../services/api";
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import COMPANIES from "../../services/ListCompany";


const AdminApiService = new AdminApi()

export default {
    data() {
        return {
            role: '',
            notifications: [],
            showNotification: false,
            showDialogApp: false
        }
    },
    methods: {
        getNotifications: getNotifications,
        deleteNotification: deleteNotification,
        getStyle: getStyle,
        getConfig: getConfig,
        isLink: isLink,
        detectAgent: detectAgent,
        close: close,
        isSimpleText: isSimpleText,
        onButtonClicked: onButtonClicked,
        getButtonText: getButtonText,
        isButton: isButton,
        openTerms:openTerms
    },
    beforeMount() {
        if(CONFIG_COMPANY.NAME !== COMPANIES.CFNS.NAME){
            this.$router.push('/home-page');
            return;
        }
        this.role = session.getRole();
        this.getConfig();


    }
}


function getConfig(){
    if(!session.shouldFetchConfig()) {
        this.showNotification = session.getConfig().showNotificationOnHome
        this.showDialogApp = session.getConfig().shouldAskToDownloadApps
        this.getNotifications()
        this.detectAgent()
        return;
    }
    let _self = this;
    AdminApiService.getCompanyConfiguration(CONFIG_COMPANY.NAME)
        .then((response) => {
            session.saveConfig(response.data)
            session.setLastFetchConfig();
            _self.showNotification = session.getConfig().showNotificationOnHome
            _self.showDialogApp = session.getConfig().shouldAskToDownloadApps
            _self.getNotifications()
            _self.detectAgent()
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function detectAgent() {
    if(!this.showDialogApp) return;
    let androidUrl = session.getConfig().googlePlay;
    let aAndroid = '<a href=\"' + androidUrl +'\">';
    let iosUrl = session.getConfig().appStore;
    let aios = '<a href=\"' + iosUrl +'\">';
    if(navigator.userAgent.toString().includes("Android")){
        swal({
            title: 'Preuzmi aplikaciju klikom na ikonicu',
            html : '<html><div class="foo">' +
                '<br>' +
                aAndroid +
                '<div class="dialog-google-play"></div>'+
                '</a>' +
                '<br>'+
                // '<a><u>Ne sada</u></a>'+
                '</div></html>',
            text: "",
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Ne sada',
            customClass: 'swal2-warning'
        }).then(function () {

        });
    }else if(navigator.userAgent.toString().includes("iPhone")){
        swal({
            title: 'Preuzmi aplikaciju klikom na ikonicu',
            html : '<html><div class="foo">' +
                '<br>' +
                aios +
                '<div class="dialog-app-store"></div>'+
                '</a>' +
                '<br>'+
                // '<a><u>Ne sada</u></a>'+
                '</div></html>',
            text: "",
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Ne sada',
            customClass: 'swal2-warning'
        }).then(function () {

        });
    }
}

function close() {
    swal.close()
}

function getNotifications() {
    AdminApiService.getNotification(CONFIG_COMPANY.NAME)
        .then((response) => {
            this.notifications = response.data
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function getStyle(notification) {
    if(notification.priority === 'LOW'){
        return "color: white; font-size: 20px;"
    }else if(notification.priority === 'MEDIUM'){
        return "color: orange; font-size: 20px;"
    } else if(notification.priority === 'HIGH'){
        return "color: red; font-size: 20px;"
    }
}

function deleteNotification(notification) {
    AdminApiService.deleteNotifications(notification.id)
        .then((response) => {
            this.getNotifications()
            swal('Uspešno','Uspešno obrisano obaveštenje', 'success')
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function isLink(text) {
    return (text.includes('http') || text.includes('www')) && !text.includes('<-dugme->')
}

function isSimpleText(text) {
    return !text.includes('http') && !text.includes('www') && !text.includes('<-dugme->')
}

function isButton(text) {
    return text.includes('<-dugme->')
}

function onButtonClicked(text) {
    let temp = text.split('<-dugme->')[1]
    window.open(temp, "_blank");
}

function getButtonText(text) {
    return text.split('<-dugme->')[0]
}

function openTerms(){
    this.$router.push('/terms');
}


// WEBPACK FOOTER //
// ./src/components/Home/Home.js